import * as types from './mutations-type'
// import { loadLanguageAsync } from '@/locales'

export default {
  // // 设置语言
  // setLang ({ commit }, lang) {
  //   return new Promise(resolve => {
  //     commit(types.SET_LANG, lang)
  //     loadLanguageAsync(lang)
  //     resolve()
  //   })
  // },
  addGlobalLayer ({ commit, state }, layer) {
    commit(types.SET_GLOBAL_LAYERS, [].concat(state.globalLayers, [layer]))
  },
  removeGlobalLayer ({ commit, state }, layerName) {
    const rest = state.globalLayers.filter(item => item.name !== layerName)
    commit(types.SET_GLOBAL_LAYERS, rest)
  },
  clearGlobalLayers ({ commit }) {
    commit(types.SET_GLOBAL_LAYERS, [])
  }
}
